import type { AxiosInstance } from "axios";
import type { U2000SearchPayload } from "../../components/tables/basic/U2000BasicTable";
import type { U2000Notification, U2000NotificationSearchResult, U2000NotificationUnreadCount } from "../../types/U2000NotificationTypes";

const NOTIFICATION_URL = "U2105";

type NotificationEndpointsType = {
  INITLU: string;
  SEARCH: string;
  GET: (id: string) => string;
  UNREAD_COUNT: string;
  MARK_AS_READ: (id: string) => string;
  MARK_AS_UNREAD: (id: string) => string;
  MARK_ALL_AS_READ: string;
  DELETE: (id: string) => string;
};

const NotificationEndpoints: NotificationEndpointsType = {
  INITLU: `${NOTIFICATION_URL}/initLU`,
  SEARCH: `${NOTIFICATION_URL}/search`,
  GET: (id: string) => `${NOTIFICATION_URL}/${id}`,
  UNREAD_COUNT: `${NOTIFICATION_URL}/unread-count`,
  MARK_AS_READ: (id: string) => `${NOTIFICATION_URL}/${id}/read`,
  MARK_AS_UNREAD: (id: string) => `${NOTIFICATION_URL}/${id}/unread`,
  MARK_ALL_AS_READ: `${NOTIFICATION_URL}/mark-all-read`,
  DELETE: (id: string) => `${NOTIFICATION_URL}/${id}`,
};

/**
 * Initialisation de l'unité logique U2105
 */
export const doInitLU = (axios: AxiosInstance) => {
  return axios.get(NotificationEndpoints.INITLU);
};

/**
 * Recherche paginée de notifications
 */
export const doSearch = (axios: AxiosInstance, searchPayload: U2000SearchPayload) => {
  return axios.post<U2000NotificationSearchResult>(NotificationEndpoints.SEARCH, searchPayload);
};

/**
 * Récupérer une notification par ID
 */
export const doGetNotification = (axios: AxiosInstance, id: string) => {
  return axios.get<U2000Notification>(NotificationEndpoints.GET(id));
};

/**
 * Récupérer le nombre de notifications non lues
 */
export const doGetUnreadCount = (axios: AxiosInstance) => {
  return axios.get<U2000NotificationUnreadCount>(NotificationEndpoints.UNREAD_COUNT);
};

/**
 * Marquer une notification comme lue
 */
export const doMarkAsRead = (axios: AxiosInstance, id: string) => {
  return axios.patch(NotificationEndpoints.MARK_AS_READ(id));
};

/**
 * Marquer une notification comme non lue
 */
export const doMarkAsUnread = (axios: AxiosInstance, id: string) => {
  return axios.patch(NotificationEndpoints.MARK_AS_UNREAD(id));
};

/**
 * Marquer toutes les notifications comme lues
 */
export const doMarkAllAsRead = (axios: AxiosInstance) => {
  return axios.post(NotificationEndpoints.MARK_ALL_AS_READ);
};

/**
 * Supprimer une notification (soft delete)
 */
export const doDeleteNotification = (axios: AxiosInstance, id: string) => {
  return axios.delete(NotificationEndpoints.DELETE(id));
};
